import { animated, useSpring } from "@react-spring/web";
import style from "../style/layout.module.css";
import { useRef } from "react";
import { ComeInSlideAnimation } from "../animation";

export default function Intro({ startHandler }) {
  const textAnimation = useSpring(ComeInSlideAnimation("up", 10, 1000, 500));
  const imgAnimation = useSpring(ComeInSlideAnimation("up", 20, 1000, 650));
  const btnAnimation = useSpring(ComeInSlideAnimation("up", 10, 1000, 750));
  return (
    <div className={style.intro}>
      <div className={style.intro_bg}>
        <img src="/worldcup/imgs/intro.png" alt="intro_background" />
      </div>
      <animated.div
        className={style.intro_title}
        style={{ ...textAnimation, textAlign: "center" }}
      >
        <div className={style.intro_img}>
          <img src="/worldcup/imgs/subtract.png" alt="theable" />
        </div>
        <span>The Able</span>
        <h1>이상형 월드컵</h1>
      </animated.div>

      <animated.div className={style.intro_product} style={{ ...imgAnimation }}>
        {/* <p>이상형 찾고 경품에 응모하세요!</p>
        <p>11.02(목) ~ 11.12(일) </p> */}
      </animated.div>
      <animated.button
        type="button"
        onClick={startHandler}
        className={style.intro_btn}
        style={{ ...btnAnimation }}
      >
        <span>바로시작!</span>
      </animated.button>
    </div>
  );
}
